import PropTypes from 'prop-types';
import React, {useContext, useRef} from 'react';

import TransformSelection from './TransformSelection';

import {VirtualTrayContext} from '../VirtualTray/VirtualTrayContext';

import {DragDropType} from '../../../constants/dataEnum';

function TransformSelectionContainer({
  itemID,
  col,
  row,
  onHoverTransformSelection,
  onDragTransformSelection,
  onDropTransformSelection,
  layouts,
  setHoveredWell,
  hoveredWell,
}) {
  const virtualTrayContext = useContext(VirtualTrayContext);
  const {setDraggedLayout, setDraggedHandle} = virtualTrayContext || {};

  const wrapperRef = useRef(null);

  const isDisableDrop = () => {
    const isDisable = false;

    return isDisable;
  };

  const onHover = (item, itemId, clientOffset, dropZoneContainer) => {
    const {height, width, left, top} = dropZoneContainer;
    const wellSize = {height: height / col, width: width / row};

    const targetRow = Math.ceil((width + left - clientOffset.x) / wellSize.width);
    const targetColumn = Math.ceil((clientOffset.y - top) / wellSize.height);

    if (hoveredWell.row === targetRow && hoveredWell.column === targetColumn) {
      return;
    }

    onHoverTransformSelection(itemId, clientOffset, itemID, targetRow, targetColumn);

    setHoveredWell({column: targetColumn, row: targetRow});
  };

  const onDrag = () => {
    onDragTransformSelection(itemID);
  };

  const onDrop = (item, destItemID, isDropable, clientOffset, dropZoneContainer) => {
    onDropTransformSelection(destItemID, clientOffset, dropZoneContainer, itemID, col, row);
  };

  return (
    <TransformSelection
      ID={itemID}
      itemType={DragDropType.TRANSFORM_SELECTION}
      onDrag={onDrag}
      onDrop={onDrop}
      onHover={onHover}
      isDisableDrop={isDisableDrop}
      row={row}
      col={col}
      layouts={layouts}
      setDraggedLayout={setDraggedLayout}
      setDraggedHandle={setDraggedHandle}
      wrapperRef={wrapperRef}
      deckID={itemID}
      setHoveredWell={setHoveredWell}
      hoveredWell={hoveredWell}
    />
  );
}

TransformSelectionContainer.propTypes = {
  itemID: PropTypes.number.isRequired,
  col: PropTypes.number.isRequired,
  row: PropTypes.number.isRequired,
  onHoverTransformSelection: PropTypes.func.isRequired,
  onDragTransformSelection: PropTypes.func.isRequired,
  onDropTransformSelection: PropTypes.func.isRequired,
  layouts: PropTypes.object.isRequired,
  setHoveredWell: PropTypes.func.isRequired,
  hoveredWell: PropTypes.object.isRequired,
};
export default TransformSelectionContainer;
